import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-footer-sticky], [xpoFooterSticky]',
  host: {
    class: 'xpo-Footer--sticky',
  },
})
export class XpoFooterStickyDirective {}
